import React, { useMemo } from 'react';
import type { Nav4DragAndDropMenuItemProps } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { ActionButtons } from '../../common/ui/action-buttons/ActionButtons.tsx';
import { DashboardsDefault } from './default/index.tsx';

export type Nav4DashboardsProps = Nav4DragAndDropMenuItemProps & {
	isExpanded: boolean;
};

export function Nav4Dashboards(props: Nav4DashboardsProps): React.JSX.Element {
	const actionButtons = useMemo(() => <ActionButtons />, []);
	const isExpandedValue = fg('navx-global-side-nav')
		? !!props.isExpandOrFlyoutOpen && props.isExpanded
		: props.isExpanded;

	return (
		<DashboardsDefault actionsOnHover={actionButtons} {...props} isExpanded={isExpandedValue} />
	);
}
